import { render, staticRenderFns } from "./Trustflix.vue?vue&type=template&id=fd5b0d66&scoped=true"
import script from "./Trustflix.vue?vue&type=script&lang=js"
export * from "./Trustflix.vue?vue&type=script&lang=js"
import style0 from "./Trustflix.vue?vue&type=style&index=0&id=fd5b0d66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5b0d66",
  null
  
)

export default component.exports